import { upperCaseFirst } from 'upper-case-first'

export function toLowerCase(value)
{
    return value.toLocaleLowerCase()
}

export function toUpperCase(value)
{
    return value.toLocaleUpperCase()
}

export function toUpperCaseFirst(value)
{
    return upperCaseFirst(toLowerCase(value))
}

export function toTitleCase(value)
{
    return toLowerCase(value)
        .replace(/(^.)|([ \-'\t][^\-'\s])/g,
        function($1){
            return toUpperCase($1);
        }
    );
}

export function removeAccents(value)
{
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, '')
}
